import React, { useState, useEffect } from "react";
import { Box, Typography, Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import axios from "axios";
import ErrorAlert from "helper/errorAlert";
import { useApiClient } from "context/ApiClientContext";
import { toast } from "react-toastify";


export default function OutputPlatform({ apiSetting, updateApiSetting }) {
    const labelWidth = 130;
    const [dataList, setDataList] = useState({});
    const [options, setOptions] = useState([]);
    const apiClient = useApiClient();


    useEffect(() => {
        setDataList(apiSetting);
    }, [apiSetting]);

    useEffect(() => {
        // Fetch the data from the API when the component mounts
        const fetchOptions = async () => {
            try {
                const response = await axios.get(
                    `${apiClient}/outputplatform`,
                    {
                      headers: {
                        Authorization: `Bearer ${localStorage.getItem('token')}`,
                        Accept: "application/json",
                      },
                    }
                  );
                  
                  const optionsArray = response.data.data;

                  const formattedOptions = optionsArray.map(option => ({
                      value: option,
                      label: option,
                  }));
      
                  setOptions(formattedOptions); 
            } catch (error) {
                toast.error(error, {
                  position: "top-right",
                });
                ErrorAlert(error)
                return error;
            }
        };
        fetchOptions();
    }, []);

    const handleChange = (event) => {
        handleCreate("outputplatform", event);
    };

    const handleCreate = (property, event) => {
        const selectChange = { ...dataList };
        selectChange[property] = event.target.value;

        setDataList(selectChange);
        updateApiSetting(selectChange);
    };

    return (
        <Box p={3}>
            <Box display="flex" mb={2} sx={{ marginTop: "-40px" }}>
                <Typography
                    display="flex"
                    alignItems="center"
                    pr={4}
                    sx={{ minWidth: labelWidth, paddingRight: "123px" }}
                >
                    Output Platform
                </Typography>
                <FormControl variant="outlined" size="small" sx={{ width: 200 }}>
                    <InputLabel id="dropdown-label">Option</InputLabel>
                    <Select
                        labelId="dropdown-label"
                        id="dropdown"
                        value={dataList?.outputplatform || ""} // Default to empty string if no value
                        onChange={handleChange}
                        label="Option"
                    >
                        <MenuItem value="">
                            <em>None</em>
                        </MenuItem>
                        {options.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        </Box>
    );
}
